import { trans } from "utils/helpers";
import { CheckableButton } from "../CheckableButton/CheckableButton"
import "./style.scss"
import React from "react";
interface CheckableButtonListPropsType {
    checkableBtnLabelList: any[],
    checkableListLabel?: string,
    value?: string,
    verticalDirection: boolean,
    checkableButtonName?: string, // اگر چک باکس باشد نیازی به نام ندارد
    checkbaleType: "checkbox" | "radio",
    useTrans?:boolean,
    disable?:boolean,
    required?:boolean,
    onchange?: (e:any ,event?:any) => void
    mode?:string,
}
export const CheckableButtonList = ({ onchange,  mode,disable=false,required=false,value,useTrans=true, checkableBtnLabelList, checkableListLabel, verticalDirection, checkableButtonName, checkbaleType }: CheckableButtonListPropsType) => {
    return (
        <>
            {checkableListLabel ? <label className="checkable-btn-list-wrapper__label">{useTrans ? trans(checkableListLabel) : checkableListLabel}</label> : null}
            {required && <span className="text-danger me-1">*</span>}
        <div className="checkable-btn-list-wrapper ">
            <div className={`checkable-btn-list ${verticalDirection == true ? "checkable-btn-list--vertical" : ""}`} >
                <div className="" style={{display: "flex",flexDirection:`${verticalDirection == true?'column':'row'}`,justifyContent: "space-between", width: "100%", marginTop: "-6px"}}>

                {checkableBtnLabelList.map((item, index) => (
                    <React.Fragment key={index}>
                    <CheckableButton onchange={(e)=>{if(e){onchange&&onchange(item?.SystemKey)}}}  defaultChecked={item?.SystemKey ? item?.SystemKey== value : value==item} checked={item?.SystemKey ? item?.SystemKey== value : value==item} readOnly={disable ? true : false}  useTrans={useTrans} value={item?.name ? item?.SystemKey : item} mode={mode} labelText={item?.name ? item?.name : item} inputName={checkableButtonName} type={checkbaleType} key={(item?.name ? item?.name : item) + index} />
                                         {/* <CheckableButton  defaultChecked={index ==0} useTrans={useTrans} value={label} mode={mode} labelText={label} inputName={checkableButtonName} type={checkbaleType} key={label + index} /> */}
                    </React.Fragment>
                ))}
                </div>
            </div>
        </div>
        </>
    );
}